export const routePaths = {
  auth: {
    signin: '/signin',
    signup: '/signup',
  },
  home: {
    base: '/',
  },
  institution: {
    base: '/institution',
    categories: '/institution/categories',
    list: '/institution/list',
    create: '/institution/create',
    detail: (id: string) => `/institution/${id}`,
    edit: (id: string) => `/institution/edit/${id}`,
  },
  screen: {
    base: '/screens',
    categories: '/screens/categories',
    create: '/screens/create',
    list: '/screens/list',
    status: '/screens/status',
    detail: (id: string) => `/screens/${id}`,
    edit: (id: string) => `/screens/edit/${id}`,
    config: (id: string | number) => `/screens/config/${id}`,
  },
  screenFrameConfig: {
    base: (id: string) => `/screen-frame-configs/${id}`,
    edit: (id: string) => `/screen-frame-configs/edit/${id}`,
    config: (id: string) => `/screen-frame-configs/config/${id}`,
  },
  frames: {
    base: '/frames',
    categories: '/frames/categories',
    create: '/frames/create',
    detail: (id: string) => `/frames/${id}`,
    edit: (id: string) => `/frames/edit/${id}`,
    screens: (id: string) => `/frames/${id}/screens`,
  },
  users: {
    base: '/users',
  },
  alerts: {
    base: '/alerts',
    create: '/alerts/create',
    detail: (id: string) => `/alerts/${id}`,
    edit: (id: string) => `/alerts/edit/${id}`,
  },
  playbackHistory: {
    base: '/playback-history',
    detail: '/playback-history/detail',
  },
  contentLibrary: {
    base: '/content-library',
    usage: '/content-library/usage',
  },
  componentContentHistory: {
    base: '/component-content-history',
  },
  componentContent: {
    base: '/component-content',
    history: '/component-content-history',
    create: '/component-content/create/:componentId',
    approvalPendings:'/component-content/approval-pendings'
  },
  preview:{
    base:'/preview'
  }
}

export default routePaths
